export default __webpack_public_path__ + "static/media/boardCustomType.3e31b524.csv";